"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductListFilter = void 0;
const ProductListFilterItem_1 = require("./ProductListFilterItem");
const ProductListFilterItemSelect_1 = require("./ProductListFilterItemSelect");
const ProductListFilterItemBoolean_1 = require("./ProductListFilterItemBoolean");
const ProductListFilterItemRange_1 = require("./ProductListFilterItemRange");
class ProductListFilter {
    constructor() {
        this.filterItems = new Map();
    }
    /**
     * Get all request params depending on filter item values.
     */
    get requestParams() {
        const result = {};
        for (const item of this.filterItems.values()) {
            const paramValue = item.paramValue;
            if (paramValue !== "") {
                result[item.field] = paramValue;
            }
        }
        return result;
    }
    /**
     * Create FilterItem by request result available filter item.
     * @param filterItemData
     */
    static createFilterItem(filterItemData) {
        switch (filterItemData.type) {
            case ProductListFilterItem_1.ProductListFilterItemType.select:
                return new ProductListFilterItemSelect_1.ProductListFilterItemSelect(filterItemData);
            case ProductListFilterItem_1.ProductListFilterItemType.boolean:
                return new ProductListFilterItemBoolean_1.ProductListFilterItemBoolean(filterItemData);
            case ProductListFilterItem_1.ProductListFilterItemType.range:
                return new ProductListFilterItemRange_1.ProductListFilterItemRange(filterItemData);
            default:
                return undefined;
        }
    }
    applyFilterValue(filterValues) {
        for (const [field, filterItem] of this.filterItems) {
            if (filterValues[field]) {
                filterItem.value = filterValues[field];
            }
            else {
                filterItem.clear();
            }
        }
    }
    applyFilterResult(filterResults) {
        const updatedFilterItem = new Set();
        for (const filterResult of filterResults) {
            const filterResultItem = this.filterItems.get(filterResult.field);
            if (filterResultItem) {
                filterResultItem.count = filterResult.count;
                filterResultItem.applyFilterItemValueResult(filterResult.values);
            }
            else {
                this.addFilterItem(filterResult);
            }
            updatedFilterItem.add(filterResult.field);
        }
        for (const filterItem of this.filterItems.values()) {
            // Just update filter item that not updated yet.
            if (!updatedFilterItem.has(filterItem.field)) {
                filterItem.disable();
            }
        }
    }
    /**
     * Create new filter item and add it to filter item list (if valid)
     * @param itemData
     * @private
     */
    addFilterItem(itemData) {
        const item = ProductListFilter.createFilterItem(itemData);
        if (item !== undefined) {
            this.filterItems.set(item.field, item);
        }
    }
}
exports.ProductListFilter = ProductListFilter;
